import { defineStore } from 'pinia';

export const useStaffStore = defineStore({
    id: 'staff',
    state() {
        return {
            database: null,
            staffs: [],
            activeStaff: {},
        };
    },
    actions: {
        async init() {
            // await this.initDatabase();
            this.initStaffs();
        },
        async initDatabase() {
            return new Promise((resolve, reject) => {
                let db = window.indexedDB.open("limagrain_db", process.env.VUE_APP_INDEXED_DB_VERSION);

                db.onerror = () => {
                    reject('Error opening the database 2.');
                };

                db.onsuccess = (e) => {
                    this.updateDatabase(e.target.result);
                    resolve('OK');
                };

                // db.onupgradeneeded = (e) => {
                //     if (e.oldVersion === 1) {
                //         e.target.result.deleteObjectStore("staffs");
                //     }

                //     e.target.result.createObjectStore("staffs", { keyPath: "id" });
                // };
            });
        },
        async initStaffs() {
            await this.initDatabase();
            const staffs = await new Promise((resolve, reject) => {
                this.database.transaction('staffs')
                    .objectStore('staffs')
                    .getAll()
                    .onsuccess = (e) => {
                        resolve(e.target.result);
                    };
            });

            this.updateStaffs(staffs);
        },
        async getStaff(dataId) {
            await this.initDatabase();
            let id = parseInt(dataId);
            if (!this.database) {
                throw new Error('Database not initialized');
            }

            const transaction = this.database.transaction('staffs', 'readwrite');

            const staffStore = transaction.objectStore('staffs');
            const staffRequest = staffStore.get(dataId);

            staffRequest.onerror = () => {
                console.error('Error find the in the database.');
            };

            staffRequest.onsuccess = (e) => {
                const findStaff = e.target.result;
                if (findStaff) {
                    this.updateActiveStaff(findStaff);
                }
            }
        },
        async addNewStaff(data) {
            await this.initDatabase();
            const transaction = this.database.transaction('staffs', 'readwrite');

            const staffStore = transaction.objectStore('staffs');
            const staffRequest = staffStore.get(data.value);

            staffRequest.onerror = () => {
                console.error('Error find the in the database.');
            };

            staffRequest.onsuccess = (e) => {
                const findStaff = e.target.result;
                if (findStaff) {
                    findStaff.updated = new Date().getTime();

                    const updateRequest = staffStore.put(findStaff);
    
                    updateRequest.onerror = () => {
                        console.error('Error storing the updated in the database.');
                    };
    
                    updateRequest.onsuccess = () => {
                        const staffs = [...this.staffs];
                        const staffIndex = staffs.findIndex(n => n.id === findStaff.id);
                        staffs[staffIndex] = findStaff;
    
                        this.updateStaffs(staffs);
                    };
                } else {
                    const now = new Date();
                    const newData = {
                        content: data,
                        created: now.getTime(),
                        updated: now.getTime(),
                        id: data.value
                    };
        
                    const staffs = [newData, ...this.staffs];
                    this.updateStaffs(staffs);
        
                    this.updateActiveStaff(newData);
    
                    transaction.objectStore('staffs').add(newData);
                }
            }
        },

        updateDatabase(database) {
            this.database = database
        },
        updateStaffs(staffs) {
            this.staffs = staffs
        },
        updateActiveStaff(staff) {
            this.activeStaff = staff
        },
        getStaffs() {
            return this.staffs;
        }
    },
    getters: {},
});
